import type { ProspectApplicationChecks } from '../services/tenantApi';
import type { ClosingPersonalState } from '../components/closing/closing-model';

/** Same idea as applyFriendChecks on Apply — refresh headshots (and names) from the lightweight checks poll. */
export function mergeClosingPersonalFromApplicationChecks(
  personal: Record<string, ClosingPersonalState>,
  checks: ProspectApplicationChecks,
): Record<string, ClosingPersonalState> {
  const byApplicantId = new Map(checks.applicants.map((row) => [row.applicantId, row]));
  let changed = false;
  const next: Record<string, ClosingPersonalState> = { ...personal };
  for (const [personId, row] of Object.entries(personal)) {
    if (!row.applicantId) continue;
    const check = byApplicantId.get(row.applicantId);
    if (!check) continue;
    if (check.headshotDocumentId === row.headshotDocumentId) continue;
    changed = true;
    next[personId] = { ...row, headshotDocumentId: check.headshotDocumentId };
  }
  return changed ? next : personal;
}
